import { Table } from "react-bootstrap";
import React, { useState } from "react";
import useReportFetch from "./reportFetch";
import { GetReportRowsForUser } from "./getReportsRowsForUser";
import { useAuth0 } from "../../react-auth0-spa";
import { NordicModal } from "./nordicModal";
import denied from "../../Assets/images/denied.svg";
import NordicDashboard from "../nordicdashboard/NordicDashboard";

export const ReportTableSimplified = ({
  filter,
  setIsOpen,
  setIsOpenKPIFailed,
}) => {
  const [reload, setReload] = useState({});
  const { user } = useAuth0();
  const { loading, data } = useReportFetch(reload, user);
  const [isNordicPopupOpen, setIsNordicPopupOpen] = useState(false);
  const rows = GetReportRowsForUser(
    data,
    filter,
    setIsOpen,
    setIsOpenKPIFailed,
    setIsNordicPopupOpen,
    isNordicPopupOpen
  );
  return (
    <>
      <Table striped hover className="reports-table" style={styles.tableStyle}>
        <thead style={styles.tableHeader}>
          <tr>
            <th style={styles.left}>
              <div style={styles.tableDiv}>Product</div>
            </th>
            <th style={styles.left}>
              <div style={styles.tableDiv}>Publishing date</div>
            </th>
            <th>Download PDF</th>
            <th>Access Dashboard</th>
            <th>Access Analytics</th>
          </tr>
        </thead>
        {loading ? (
          <tbody>
            <td colSpan={5}>
              <div
                style={{
                  width: "124px",
                  height: "24px",
                  WebkitMask: `
            conic-gradient(from 135deg at top, #0000, #000 .5deg 90deg, #0000 90.5deg) 0 0,
            conic-gradient(from -45deg at bottom, #0000, #000 .5deg 90deg, #0000 90.5deg) 0 100%
          `,
                  WebkitMaskSize: "25% 50%",
                  WebkitMaskRepeat: "repeat-x",
                  background:
                    "linear-gradient(#000 0 0) left/0% 100% no-repeat #ddd",
                  animation: "l13 2s infinite linear",
                  margin: "20px auto",
                  textAlign: "center",
                }}
              >
                <style>
                  {`
            @keyframes l13 {
              100% { background-size: 100% 100%; }
            }
          `}
                </style>
              </div>
            </td>
          </tbody>
        ) : (
          <tbody style={styles.tableBody}>
            {loading || rows.length === 0 ? (
              <tr key="empty-row">
                <td colSpan={4}>No current analyses</td>
              </tr>
            ) : (
              rows
            )}
          </tbody>
        )}
      </Table>
      {/* <NordicModal isOpen={isNordicPopupOpen} setIsOpen={setIsNordicPopupOpen}>
        <NordicDashboard />
      </NordicModal> */}
    </>
  );
};

const styles = {
  tableStyle: {
    marginTop: "30px",
    textAlign: "center" as const,
    fontSize: "18px",
  },
  tableHeader: {
    backgroundColor: "#043224",
    color: "#fff",
  },
  tableBody: {
    borderTop: "none",
    verticalAlign: "middle",
  },
  tableBodyRow: {
    height: "40px",
  },
  left: {
    textAlign: "left" as const,
  },
  tableDiv: {
    width: "95%",
    marginLeft: "auto" as const,
    textAlign: "left" as const,
  },
};
